import React from "react";
import "./Homepage.scss";
import AboutProduct from "./Sections/AboutProduct/AboutProduct";
import BannerSection from "./Sections/BannerSection/BannerSection";
import News from "./Sections/News/News";
import Newsletter from "./Sections/Newsletter/Newsletter";
import Questions from "./Sections/Questions/Questions";
import Solution from "./Sections/Solution/Solution";
import Blog from "./Sections/Blog/Blog";
class Homepage extends React.Component {
  // state = {
  //   modalShow: false
  // };

  // componentDidMount() {
  //   if (!localStorage.getItem("intro-modal")) {
  //     this.setState({ modalShow: true });
  //   }
  // }

  // modalClose = () => {
  //   localStorage.setItem("intro-modal", true);
  //   this.setState({ modalShow: false });
  // };

  render() {
    return (
      <>
        {/* <CSModal show={this.state.modalShow} onHide={this.modalClose}>
          <img
            src={people01}
            className=".cs_modal_newsimg"
            alt="news"
            style={{ width: "100%" }}
          />

          <Translate
            component="h4"
            className="cs_modal_headline news"
            content="homepage.news-modal.headline"
          />

          <Translate
            component="p"
            className="cs_modal_txt"
            content="homepage.news-modal.text"
            unsafe={true}
          />
        </CSModal> */}
        <div className="tophalf-bg">
          <BannerSection scrollAnchor="top" />
          <AboutProduct scrollAnchor="aboutproduct" />
          <Solution scrollAnchor="solution" />
        </div>
        <div className="bottomhalf-bg">
          <Questions scrollAnchor="questions" />
          {/* <RoadMap /> */}

          {/* <Team /> */}
          {/* <News scrollAnchor="news" /> */}
          <Blog scrollAnchor="blog" />
        </div>
        {/* <Partners scrollAnchor="partners" /> */}
        <Newsletter />
      </>
    );
  }
}
export default Homepage;
